interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

const buildPages = (page: number, totalPages: number): (number | string)[] => {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }
  const pages: (number | string)[] = [1];
  const start = Math.max(2, page - 1);
  const end = Math.min(totalPages - 1, page + 1);
  if (start > 2) pages.push("left-ellipsis");
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < totalPages - 1) pages.push("right-ellipsis");
  pages.push(totalPages);
  return pages;
};

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = buildPages(page, totalPages);

  return (
    <nav className="mt-10 flex items-center justify-center gap-1.5" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="flex h-9 items-center gap-1 rounded-md border border-background-700 px-3 text-sm text-foreground-200 transition-colors hover:border-accent-400 hover:text-accent-400 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-700 disabled:hover:text-foreground-200"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {pages.map((entry) =>
        typeof entry === "number" ? (
          <button
            key={entry}
            type="button"
            onClick={() => onChange(entry)}
            aria-current={entry === page ? "page" : undefined}
            className={`h-9 min-w-9 rounded-md px-2 text-sm transition-colors ${
              entry === page
                ? "bg-accent-500 font-semibold text-background-950"
                : "border border-background-700 text-foreground-200 hover:border-accent-400 hover:text-accent-400"
            }`}
          >
            {entry}
          </button>
        ) : (
          <span key={entry} className="px-1 text-foreground-500">
            …
          </span>
        ),
      )}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="flex h-9 items-center gap-1 rounded-md border border-background-700 px-3 text-sm text-foreground-200 transition-colors hover:border-accent-400 hover:text-accent-400 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-700 disabled:hover:text-foreground-200"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}